/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import { string } from 'prop-types';
import dayjs from 'dayjs';

/**
 * This is the FormatDate component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
const FormatDate = ({ className, date, format }) => {
  const formatted = dayjs(date).format(format);

  return <span className={className}>{formatted}</span>;
};

/**
 * Declare expected property types.
 *
 * @type {Object}
 */
FormatDate.propTypes = {
  date: string.isRequired,
  format: string,
  className: string,
};

FormatDate.defaultProps = {
  format: 'DD MMMM YYYY',
  className: null,
};

export default FormatDate;
